module.exports = __webpack_public_path__ + "img/10-1.800e8e82.png";